import { Link } from "react-scroll";

export const HashLink = ({ id, text, offset, className, ...props }) => {
  return (
    <Link
      className={className}
      to={id}
      smooth
      offset={offset}
      duration={0}
      delay={0}
      {...props}
    >
      {text}
    </Link>
  );
};
